const html = document.querySelector('html');
const head = document.querySelector('head');
const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const reverseBreakpoints = [...breakpoints].reverse();

export function isBreakpoint(breakpoint) {
    let currentBreakpoint = window.getComputedStyle(head).content.replaceAll('"', '');
    return (breakpoint.toLowerCase() == currentBreakpoint) ? true : false;
}

export function isMinBreakpoint(breakpoint) {
    let i = breakpoints.indexOf(breakpoint);

    if (i === -1) {
        return false;
    }

    let currentBreakpoint = window.getComputedStyle(head).content.replaceAll('"', '');
    let minBreakpoints = breakpoints.slice(i);

    return (minBreakpoints.indexOf(currentBreakpoint) !== -1) ? true : false;
}

(($) => {
    let $html = $('html');
    let $head = $('head');

    let previousBreakpoint = false;

    updateBreakpoint();

    $(window).on('resize', onWindowResize);

    function onWindowResize(event) {
        if (!event instanceof Event) {
            return false;
        }

        updateBreakpoint();
    }

    function updateBreakpoint() {
        for (let i in reverseBreakpoints) {
            /* TODO: show only active breakpoint size classes */
            if (isMinBreakpoint(reverseBreakpoints[i])) {
                $html.removeClass(reverseBreakpoints.map(b => 'min-' + b).join(' '));

                let minBreakpoints = reverseBreakpoints.slice(i);
                for (let n in minBreakpoints) {
                    $html.addClass(minBreakpoints.reverse().map(b => 'min-' + b).join(' '));
                }

                break;
            }
        }

        for (let i in breakpoints) {
            if (isBreakpoint(breakpoints[i])) {
                $html.removeClass(breakpoints.map(b => 'is-' + b).join(' '));
                $html.addClass('is-' + breakpoints[i]);

                if (previousBreakpoint !== breakpoints[i]) {
                    previousBreakpoint = breakpoints[i];
                    $html.trigger('breakpoint:' + breakpoints[i]);
                }

                break;
            }
        }
    }
})(jQuery);